import { useState } from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/interactives/Tooltip'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { cn } from '@/utils'

import { useToggleAllGroups } from '../cue/cue.hooks'

export function RundownHeaderCollapseGroupsToggle() {
  const [toggleStatus, setToggleStatus] = useState(true)
  const toggleAllGroups = useToggleAllGroups()

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex-none w-full h-7 rounded-sm opacity-70 text-gray-500 group-hover:opacity-70 hover:opacity-100! transition-opacity text-xs focus:outline-hidden focus:ring-3"
          onClick={() => {
            toggleAllGroups(toggleStatus)
            setToggleStatus(!toggleStatus)
          }}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            className={cn(['transition-all', toggleStatus ? '' : '-rotate-90'])}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent>
        {toggleStatus ? 'Collapse' : 'Expand'} all groups
      </TooltipContent>
    </Tooltip>
  )
}
